import React, { Component } from "react";
import * as Constants from "../../../../Constants/index";
import axios from "axios";
import SimpleReactValidator from "simple-react-validator";
import Footer from "../../../footer/footer.component";

class Geodatas extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    // this.getFoodRequest = this.getFoodRequest.bind(this);
    // this.handleClickActiveTab = this.handleClickActiveTab.bind(this);
  }


  render() {
    return (
      <>
        <>
        <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
          <nav class="navbar navbar-main navbar-expand-lg position-sticky mt-4 top-1 px-0 mx-4 shadow-none border-radius-xl z-index-sticky" id="navbarBlur" data-scroll="true">
            <div class="container-fluid py-1 px-3">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">

                  <li class="breadcrumb-item text-sm"><a class="opacity-5 text-dark">Georaphy</a></li>
                  <li class="breadcrumb-item text-sm text-dark active" aria-current="page">Data</li>
                </ol>
              </nav>
              <div class="sidenav-toggler sidenav-toggler-inner d-xl-block d-none ">
                <a class="nav-link text-body p-0">
                  <div class="sidenav-toggler-inner">
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                  </div>
                </a>
              </div>
              <div class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
                <div class="ms-md-auto pe-md-3 d-flex align-items-center">
                  <div class="input-group input-group-outline">
                    <input type="text" class="form-control" placeholder="Search"
                      />
                  </div>
                </div>
                <ul class="navbar-nav  justify-content-end">

                </ul>
              </div>
            </div>
          </nav>
          <div class="container-fluid py-4">
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header pb-0">
                    <div class="d-lg-flex">
                      <div>
                        <h5 class="mb-0">Geo Data</h5>

                      </div>
                      <div class="ms-auto my-auto mt-lg-0 mt-4">
                        <div class="ms-auto my-auto">
                          <div class="modal fade" id="import" tabindex="-1" aria-hidden="true">
                            <div class="modal-dialog mt-lg-10">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <h5 class="modal-title" id="ModalLabel">Import CSV</h5>
                                  <i class="material-icons ms-3">file_upload</i>
                                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div class="modal-body">
                                  <p>You can browse your computer for a file.</p>
                                  <div class="input-group input-group-dynamic mb-3">
                                    <label class="form-label">Browse file...</label>
                                    <input type="email" class="form-control" onfocus="focused(this)" onfocusout="defocused(this)" />
                                  </div>
                                  <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="importCheck" checked="" />
                                    <label class="custom-control-label" for="importCheck">I accept the terms and conditions</label>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button type="button" class="btn bg-gradient-secondary btn-sm" data-bs-dismiss="modal">Close</button>
                                  <button type="button" class="btn bg-gradient-primary btn-sm">Upload</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-body px-0 pb-0">
                    <div class="table-responsive">
                      <table class="table table-flush" id="products-list">
                        <thead class="thead-light">
                          <tr>
                            <th >
                              ID
                            </th>
                            <th >
                              Flag
                            </th>
                            <th >
                              Name
                            </th>
                            <th >
                              Created On
                            </th>
                            <th >
                              Modified On
                            </th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>

                        </tbody>

                      </table>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </main>
        </>
      </>
    );
  }
}

export default Geodatas;
